import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TPipelineScheduleProps } from '@/console/features/pipelines/components/pipeline-schedule/pipeline-schedule.types';
import { timePickerOptionsUS } from '@/console/features/pipelines/components/pipeline-trigger-configuration/pipeline-trigger-configuration.constants';
import { Tag } from '@/shared/components/ui/tag/tag';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { fromCronExpression } from '@/shared/utils/transform';

export const PipelineSchedule: React.FC<TPipelineScheduleProps> = ({
  expression,
  timezone,
  ...props
}) => {
  const { t } = useTranslation();
  const schedule = fromCronExpression(expression, timezone);

  const convertToUsFormat = () => {
    if (navigator.language === 'en-US') {
      return timePickerOptionsUS.find(
        ({ value }) => value === schedule?.timeOfDay,
      )?.label;
    }

    return schedule?.timeOfDay;
  };

  const weekdays = [
    t('common:weekdays_long.sun'),
    t('common:weekdays_long.mon'),
    t('common:weekdays_long.tue'),
    t('common:weekdays_long.wed'),
    t('common:weekdays_long.thu'),
    t('common:weekdays_long.fri'),
    t('common:weekdays_long.sat'),
  ];

  const usedDays =
    weekdays.filter((_, index) =>
      schedule?.days?.some((day) => day === index + 1),
    ) ?? [];

  if (!schedule?.days?.length) {
    return null;
  }

  return (
    <Tooltip
      title={
        <Stack gap="0.25rem">
          {usedDays.map((day) => (
            <Tag key={day} label={day} />
          ))}
        </Stack>
      }
    >
      <Typography {...props} noWrap>
        {t('pipelines:schedule_applied', {
          count: schedule?.days?.length,
          time: convertToUsFormat(),
        })}
      </Typography>
    </Tooltip>
  );
};
